module.exports = __webpack_public_path__ + "static/media/he-111.91c3c606.jpg";